import React from 'react'
import keyBy from 'lodash/keyBy'
import {
  TextField,
  useQuery,
  Datagrid,
  Pagination,
  ListContextProvider,
  ArrayField,
} from 'react-admin'
import { usePagination } from '../../../hooks'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export const StatisticList = (props) => {
  const { page, perPage, setPage, setPerPage } = usePagination()
  const currentClubId = props.record.id
  const { data, total } = useQuery({
    type: 'getList',
    resource: `clubs/${currentClubId}/tournaments-stats`,
    payload: {
      pagination: { page, perPage },
      sort: { field: 'id', order: 'ASC' },
    },
  })
  return (
    <ListContextProvider
      value={{
        resource: 'tournaments-stats',
        basePath: '/clubs',
        data: keyBy(data, 'id'),
        ids: data?.map((el) => el.id),
        currentSort: { field: 'id', order: 'ASC' },
        selectedIds: [],
      }}
    >
      <Datagrid>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <TextField source='name' label='' emptyText='Не указано' />
          </AccordionSummary>
          <AccordionDetails>
            <ArrayField
              source='clubCategories'
              fieldKey='id'
              empty='Не указано'
            >
              <Datagrid>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1a-content'
                    id='panel1a-header'
                  >
                    <TextField source='name' label='' emptyText='Не указано' />
                  </AccordionSummary>
                  <AccordionDetails>
                    <Datagrid>
                      <TextField source='gold' label='Золото' />
                      <TextField source='silver' label='Серебро' />
                      <TextField source='bronze' label='Бронза' />
                    </Datagrid>
                  </AccordionDetails>
                </Accordion>
              </Datagrid>
            </ArrayField>
          </AccordionDetails>
        </Accordion>
      </Datagrid>
      <Pagination
        page={page}
        perPage={perPage}
        setPage={setPage}
        total={total}
        setPerPage={setPerPage}
      />
    </ListContextProvider>
  )
}
